const LeakedPasswordIcon = () => {
  return (
    <svg
      width={25}
      height={26}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13C0 9.54822 2.79822 6.75 6.25 6.75C8.5645 6.75 10.5838 8.00811 11.6637 9.875H21.875C22.0822 9.875 22.2809 9.95731 22.4274 10.1038L24.7712 12.4476C25.0763 12.7527 25.0763 13.2473 24.7712 13.5524L22.4274 15.8962C22.1223 16.2013 21.6277 16.2013 21.3226 15.8962L20.3125 14.8861L19.3024 15.8962C18.9973 16.2013 18.5027 16.2013 18.1976 15.8962L17.1875 14.8861L16.1774 15.8962C15.8723 16.2013 15.3777 16.2013 15.0726 15.8962L14.0625 14.8861L13.0524 15.8962C12.9059 16.0427 12.7072 16.125 12.5 16.125H11.6637C10.5838 17.9919 8.5645 19.25 6.25 19.25C2.79822 19.25 0 16.4518 0 13ZM6.25 8.3125C3.66117 8.3125 1.5625 10.4112 1.5625 13C1.5625 15.5888 3.66117 17.6875 6.25 17.6875C8.11873 17.6875 9.73362 16.594 10.4868 15.0085C10.6162 14.7361 10.8909 14.5625 11.1925 14.5625H12.1764L13.5101 13.2288C13.8152 12.9237 14.3098 12.9237 14.6149 13.2288L15.625 14.2389L16.6351 13.2288C16.9402 12.9237 17.4348 12.9237 17.7399 13.2288L18.75 14.2389L19.7601 13.2288C20.0652 12.9237 20.5598 12.9237 20.8649 13.2288L21.875 14.2389L23.1139 13L21.5514 11.4375H11.1925C10.8909 11.4375 10.6162 11.2639 10.4868 10.9915C9.73362 9.40599 8.11873 8.3125 6.25 8.3125Z"
        fill="#0EC9AC"
      />
      <path
        d="M6.25 13C6.25 13.8629 5.55045 14.5625 4.6875 14.5625C3.82455 14.5625 3.125 13.8629 3.125 13C3.125 12.1371 3.82455 11.4375 4.6875 11.4375C5.55045 11.4375 6.25 12.1371 6.25 13Z"
        fill="#0EC9AC"
      />
    </svg>
  )
}

export default LeakedPasswordIcon